<template>
  <div>
    <h3 class="form-title">🔄 帳戶轉帳</h3>
    <form @submit.prevent="add_transfer_event" class="styled-form">
      <div class="form-group">
        <label>從</label>
        <select v-model="curritem1" required>
          <option v-for="x in transfer" :key="x" :value="x">{{ x }}</option>
        </select>
      </div>
      <div class="arrow-row">↓</div>
      <div class="form-group">
        <label>轉入</label>
        <select v-model="curritem2" required>
          <option v-for="x in transfer" :key="x" :value="x">{{ x }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>金額</label>
        <div class="input-prefix">
          <span class="prefix">$</span>
          <input type="number" v-model="cost" placeholder="0" required />
        </div>
      </div>
      <label class="checkbox-row">
        <input type="checkbox" v-model="yesterday" />
        <span>記錄為前一日</span>
      </label>
      <button type="submit" class="btn-submit" :disabled="adding">
        {{ adding ? '處理中...' : '🔄 確認轉帳' }}
      </button>
    </form>
    <div v-if="success" class="toast toast-success">✅ 轉帳成功！</div>
  </div>
</template>

<script>
import axios from 'axios'
axios.defaults.baseURL = 'https://mb.kman.idv.tw:9579/';

export default {
  data() {
    return {
      transfer: [],
      curritem1: null,
      curritem2: null,
      cost: null,
      token: null,
      yesterday: false,
      adding: false,
      success: false
    };
  },
  async mounted() {
    const response = await axios.get('get_transfer_item', {
      headers: { Authorization: `Bearer ${this.$store.getters.setToken}` }
    });
    this.transfer = response.data;
    this.curritem1 = this.transfer[0];
    this.curritem2 = this.transfer[0];
  },
  methods: {
    async add_transfer_event() {
      this.adding = true;
      try {
        await axios.post('transferevent', {
          curritem1: this.curritem1,
          curritem2: this.curritem2,
          cost: this.cost,
          token: this.$store.getters.setToken,
          yesterday: this.yesterday
        });
        this.cost = null;
        this.yesterday = false;
        this.success = true;
        setTimeout(() => { this.success = false; }, 2500);
      } catch (e) {
        alert('轉帳失敗');
      } finally {
        this.adding = false;
      }
    }
  }
};
</script>
<style scoped>
.form-title { font-size: 17px; font-weight: 700; margin-bottom: 20px; }
.styled-form { display: flex; flex-direction: column; gap: 14px; }
.form-group { display: flex; flex-direction: column; gap: 5px; }
.form-group label { font-size: 13px; font-weight: 600; color: var(--text-light); }
.form-group select,
.form-group input {
  padding: 10px 12px;
  font-size: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  outline: none;
  background: #fff;
  transition: border-color 0.15s;
}
.form-group select:focus,
.form-group input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(79,70,229,0.1);
}
.arrow-row { text-align: center; font-size: 20px; color: var(--text-light); }
.input-prefix { position: relative; }
.input-prefix .prefix {
  position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
  color: var(--text-light); font-size: 16px;
}
.input-prefix input { padding-left: 30px; width: 100%; }
.checkbox-row {
  display: flex; align-items: center; gap: 8px; cursor: pointer;
  font-size: 14px; color: var(--text);
}
.checkbox-row input[type="checkbox"] { width: 18px; height: 18px; accent-color: var(--primary); }
.btn-submit {
  padding: 12px; font-size: 15px; font-weight: 600;
  background: var(--primary); color: #fff; border: none;
  border-radius: 8px; cursor: pointer; transition: all 0.15s; margin-top: 4px;
}
.btn-submit:hover { background: var(--primary-hover); }
.btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }
.toast {
  margin-top: 14px; padding: 10px 16px; border-radius: 8px;
  font-size: 14px; font-weight: 500; text-align: center; animation: fadeIn 0.3s;
}
.toast-success { background: #ecfdf5; color: #065f46; border: 1px solid #a7f3d0; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }
</style>
